var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("List", {
    class: [
      _vm.$style.toolbar,
      ((_obj = {}),
      (_obj[_vm.$style.xAxis] = _vm.axis !== "y"),
      (_obj[_vm.$style.yAxis] = _vm.axis === "y"),
      (_obj[_vm.$style.scroll] = _vm.scroll),
      _obj),
    ],
    attrs: { keyName: _vm.keyName, list: _vm.items, tag: _vm.tag },
    scopedSlots: _vm._u(
      [
        _vm.$slots["toolbar-control"]
          ? {
              key: "first",
              fn: function () {
                return [_vm._t("toolbar-control")]
              },
              proxy: true,
            }
          : null,
        {
          key: "default",
          fn: function (ref) {
            var index = ref.index
            var item = ref.item
            return [_vm._t("default", null, { index: index, item: item })]
          },
        },
        _vm.$slots["toolbar-last"]
          ? {
              key: "last",
              fn: function () {
                return [_vm._t("toolbar-last")]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }